import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import archiveProposal from './archiveProposal';

export default (filterData, isArchived, proposalId, proposalName, value) =>
    (dispatch) => {
        const text = isArchived ? i18next.t('Unarchive') : i18next.t('Archive');
        const message = isArchived
            ? i18next.t('Are you sure to unarchive the item "{{name}}"?', {
                  name: proposalName,
              })
            : i18next.t('Are you sure to archive the item "{{name}}"?', {
                  name: proposalName,
              });

        const dataAlert = {
            confirmText: text,
            messages: [message],
            onSuccess: () => {
                dispatch(archiveProposal(filterData, proposalId, value));
            },
            title: i18next.t('Confirmation'),
            type: alerts.ALERT_TYPE_CONFIRM,
            variant: 'warning',
        };

        dispatch(alerts.actions.show(dataAlert));
    };
